export const LEVEL2 = {
  EU: {
    config: {
      level2: '95',
    },
  },
  CA: {
    config: {
      level2: '95',
    },
  },
  US: {
    config: {
      level2: '95',
    },
  },
};
export const UNIVERSE = 'Authentication';
export const SUB_UNIVERSE = 'account-creation';
export const APP_NAME = 'account-creation';
